import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby';
import { StaticImage, GatsbyImage, getImage } from 'gatsby-plugin-image';
import parser from 'html-react-parser'
import { Link } from 'gatsby';
import EventsCalendar from 'components/Events/EventsСalendar';

export default function Events({ data }) {
    
    const querydata = useStaticQuery(graphql`
    query {
      allWpEvent {
        nodes {
          title
          uri
          content
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          excerpt
          ACFevent {
            date
            fullDate
            time
            venue
            website
          }
        }
      }
    }
  `)

    const postsPerPage = 6;
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [eventType, setEventType] = useState('Upcoming Events');

    const filteredPosts = querydata.allWpEvent.nodes
    .filter(post => post.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
        const eventDateA = new Date(a.ACFevent.date);
        const eventDateB = new Date(b.ACFevent.date);

        // If we're dealing with upcoming events, sort oldest to newest
        if (eventType === 'Upcoming Events') {
            return eventDateA - eventDateB; // Oldest to newest
        } else {
            // If we're dealing with past events, sort newest to oldest
            return eventDateB - eventDateA; // Newest to oldest
        }
    });

    
    const filteredPostsToShow = filteredPosts.filter(item => {
        const eventDate = new Date(item.ACFevent.date);
        const currentDate = new Date();

        return (
            (eventType === 'Upcoming Events' && eventDate >= currentDate) ||
            (eventType === 'Past Events' && eventDate < currentDate)
        );
    });

    const postsToShow = filteredPostsToShow.slice(
        (currentPage - 1) * postsPerPage,
        currentPage * postsPerPage
    );

    let lastMonth = null;

    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    const handleEventTypeChange = event => {
        setEventType(event.target.value);
        setCurrentPage(1);
    };

    const { blogFeaturedPosts } = data;
    return (
        <div className='blog-wrap panel-space-70'>
            <div className='container'>
                <div className='row blog-p-row'>
                    <div className='col-md-9'>
                        <select
                            className='heading-level-2 blue-color hide-mobile'
                            value={eventType}
                            onChange={handleEventTypeChange}
                        >
                            <option>Upcoming Events</option>
                            <option>Past Events</option>
                        </select>

                        <div className='blog-thumb-sec event-post-wrap'>
                            {postsToShow.length === 0 ? (
                                <div class='upcoming-event-sec'>
                                    <div className='no-upcoming-event'>
                                        No upcoming events are scheduled at this time.
                                    </div>
                                </div>
                            ) : (
                                postsToShow.map((item, index) => {
                                    const eventDate = new Date(item.ACFevent.date);
                                    const currentMonth = eventDate.getMonth();
                                    let headerMonth = null;

                                    if (lastMonth !== currentMonth) {
                                        lastMonth = currentMonth;
                                        headerMonth = (
                                            <div className='row'>
                                                <div className='co-md-12'>
                                                    <div className='rt-border-title'>
                                                        <span>
                                                            {monthNames[eventDate.getMonth()]}{' '}
                                                            {eventDate.getFullYear()}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }

                                    return (
                                        <React.Fragment key={index}>
                                            {headerMonth}
                                            <div className='row event-post-row'>
                                                <div className='col-md-6'>
                                                    <Link to={item.uri}>
                                                        <div className='event-lt-c-col'>
                                                            <time>{item.ACFevent.fullDate}</time>
                                                            <h2 className='heading-level-4-i text-uppercase black-color'>
                                                                {item.title}
                                                            </h2>
                                                            {item.excerpt && parser(item.excerpt)}
                                                        </div>
                                                    </Link>
                                                </div>
                                                <div className='col-md-6'>
                                                    <figure className='event-rt-image'>
                                                        <Link to={item.uri}>
                                                            {item.featuredImage && (
                                                                <GatsbyImage
                                                                    image={getImage(
                                                                        item.featuredImage?.node.localFile
                                                                    )}
                                                                    alt='image'
                                                                />
                                                            )}
                                                        </Link>
                                                    </figure>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
                                })
                            )}
                            <div className='row f-blog-row'>
                                <div className='col-md-12'>
                                    <div className='pagination'>
                                        {currentPage > 1 && (
                                            <button
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                            >
                                                &#8592;
                                            </button>
                                        )}
                                        {[
                                            ...Array(
                                                Math.ceil(filteredPostsToShow.length / postsPerPage)
                                            ),
                                        ].map((_, index) => {
                                            const pageNumber = index + 1;
                                            return (
                                                <button
                                                    key={pageNumber}
                                                    className={
                                                        currentPage === pageNumber ? `active` : ''
                                                    }
                                                    onClick={() => setCurrentPage(pageNumber)}
                                                >
                                                    {pageNumber}
                                                </button>
                                            );
                                        })}
                                        {currentPage <
                                            Math.ceil(
                                                filteredPostsToShow.length / postsPerPage
                                            ) && (
                                                <button
                                                    onClick={() => setCurrentPage(currentPage + 1)}
                                                >
                                                    &#8594;
                                                </button>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className='blog-sidebar'>
                            <div className='blog-search-sec'>
                                <span className='blog-search-icon'>
                                    <StaticImage
                                        src='../../../images/search-icon.png'
                                        alt='image'
                                    />
                                </span>
                                <input
                                    className='form-control'
                                    type='search'
                                    autoComplete='off'
                                    name='query'
                                    value={searchTerm}
                                    onChange={e => setSearchTerm(e.target.value)}
                                    placeholder='Search'
                                />
                            </div>
                            <div className='event-date-bx'>
                                <EventsCalendar events={querydata.allWpEvent.nodes} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
